import * as ActionTypes from "constants/ActionTypes";

// Start website scan
export const adminStartWebsiteScan = (url, config, callback) => ({
    type: ActionTypes.ADMIN_START_WEBSITE_SCAN_START,
    url,
    config,
    callback
});

export const adminStartWebsiteScanSuccess = (data) => ({
    type: ActionTypes.ADMIN_START_WEBSITE_SCAN_SUCCESS,
    payload: data
});

export const adminStartWebsiteScanFailure = (error) => ({
    type: ActionTypes.ADMIN_START_WEBSITE_SCAN_FAILURE,
    error
});

// Quick scan
export const adminQuickScan = (url, callback) => ({
    type: ActionTypes.ADMIN_QUICK_SCAN_START,
    url,
    callback
});

export const adminQuickScanSuccess = (data) => ({
    type: ActionTypes.ADMIN_QUICK_SCAN_SUCCESS,
    payload: data
});

export const adminQuickScanFailure = (error) => ({
    type: ActionTypes.ADMIN_QUICK_SCAN_FAILURE,
    error
});

// Get scan status
export const adminGetScanStatus = (scanId) => ({
    type: ActionTypes.ADMIN_GET_SCAN_STATUS_START,
    scanId
});

export const adminGetScanStatusSuccess = (data) => ({
    type: ActionTypes.ADMIN_GET_SCAN_STATUS_SUCCESS,
    payload: data
});

export const adminGetScanStatusFailure = (error) => ({
    type: ActionTypes.ADMIN_GET_SCAN_STATUS_FAILURE,
    error
});

// Get scan results
export const adminGetScanResults = (scanId) => ({
    type: ActionTypes.ADMIN_GET_SCAN_RESULTS_START,
    scanId
});

export const adminGetScanResultsSuccess = (data) => ({
    type: ActionTypes.ADMIN_GET_SCAN_RESULTS_SUCCESS,
    payload: data
});

export const adminGetScanResultsFailure = (error) => ({
    type: ActionTypes.ADMIN_GET_SCAN_RESULTS_FAILURE,
    error
});

// Get products by domain
export const adminGetScrapedProducts = (domain, options) => ({
    type: ActionTypes.ADMIN_GET_SCRAPED_PRODUCTS_START,
    domain,
    options
});

export const adminGetScrapedProductsSuccess = (data) => ({
    type: ActionTypes.ADMIN_GET_SCRAPED_PRODUCTS_SUCCESS,
    payload: data
});

export const adminGetScrapedProductsFailure = (error) => ({
    type: ActionTypes.ADMIN_GET_SCRAPED_PRODUCTS_FAILURE,
    error
});

// Get all scanned domains
export const adminGetScannedDomains = () => ({
    type: ActionTypes.ADMIN_GET_SCANNED_DOMAINS_START
});

export const adminGetScannedDomainsSuccess = (data) => ({
    type: ActionTypes.ADMIN_GET_SCANNED_DOMAINS_SUCCESS,
    payload: data
});

export const adminGetScannedDomainsFailure = (error) => ({
    type: ActionTypes.ADMIN_GET_SCANNED_DOMAINS_FAILURE,
    error
});

// Get scan history
export const adminGetScanHistory = (domain, limit) => ({
    type: ActionTypes.ADMIN_GET_SCAN_HISTORY_START,
    domain,
    limit
});

export const adminGetScanHistorySuccess = (data) => ({
    type: ActionTypes.ADMIN_GET_SCAN_HISTORY_SUCCESS,
    payload: data
});

export const adminGetScanHistoryFailure = (error) => ({
    type: ActionTypes.ADMIN_GET_SCAN_HISTORY_FAILURE,
    error
});

// Cancel scan
export const adminCancelScan = (scanId, callback) => ({
    type: ActionTypes.ADMIN_CANCEL_SCAN_START,
    scanId,
    callback
});

export const adminCancelScanSuccess = (data) => ({
    type: ActionTypes.ADMIN_CANCEL_SCAN_SUCCESS,
    payload: data
});

export const adminCancelScanFailure = (error) => ({
    type: ActionTypes.ADMIN_CANCEL_SCAN_FAILURE,
    error
});

// Delete products by domain
export const adminDeleteScrapedProducts = (domain, callback) => ({
    type: ActionTypes.ADMIN_DELETE_SCRAPED_PRODUCTS_START,
    domain,
    callback
});

export const adminDeleteScrapedProductsSuccess = (domain, count) => ({
    type: ActionTypes.ADMIN_DELETE_SCRAPED_PRODUCTS_SUCCESS,
    domain,
    count
});

export const adminDeleteScrapedProductsFailure = (error) => ({
    type: ActionTypes.ADMIN_DELETE_SCRAPED_PRODUCTS_FAILURE,
    error
});

// Get scraped product by ID
export const adminGetScrapedProduct = (productId) => ({
    type: ActionTypes.ADMIN_GET_SCRAPED_PRODUCT_START,
    productId
});

export const adminGetScrapedProductSuccess = (data) => ({
    type: ActionTypes.ADMIN_GET_SCRAPED_PRODUCT_SUCCESS,
    payload: data
});

export const adminGetScrapedProductFailure = (error) => ({
    type: ActionTypes.ADMIN_GET_SCRAPED_PRODUCT_FAILURE,
    error
});

// Poll scan status (for auto-refresh)
export const adminPollScanStatus = (scanId, intervalId) => ({
    type: ActionTypes.ADMIN_POLL_SCAN_STATUS,
    scanId,
    intervalId
});

export const adminStopPollingScanStatus = (intervalId) => ({
    type: ActionTypes.ADMIN_STOP_POLLING_SCAN_STATUS,
    intervalId
});
